import { render, staticRenderFns } from "./discon-icon.vue?vue&type=template&id=f8b5ed72&scoped=true"
import script from "./discon-icon.vue?vue&type=script&lang=js"
export * from "./discon-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b5ed72",
  null
  
)

export default component.exports